<template>
  <div>
    <div v-if="isWebScreen">
      <b-modal
        ref="popup-modal"
        centered
        hide-footer
        hide-header
        body-class="p-0"
        content-class="border-0"
      >
        <PopupContent v-on:hideModal="hideModal" />
      </b-modal>
    </div>
    <div v-else-if="show">
      <PopupContent
        v-on:hideModal="hideModal"
        v-bind:isMobileScreen="!isWebScreen"
      />
    </div>
  </div>
</template>

<script>
import PopupContent from './PopupContent'
export default {
  props: ['searchQuery'],
  data() {
    return {
      isWebScreen: window.innerWidth > 576,
      show: false
    }
  },
  methods: {
    showModal() {
      if (this.$refs['popup-modal']) {
        this.$refs['popup-modal'].show()
      } else {
        this.show = true
      }
    },
    hideModal() {
      if (this.$refs['popup-modal']) {
        this.$refs['popup-modal'].hide()
      } else {
        this.show = false
      }
    }
  },
  components: {
    PopupContent
  },
  watch: {
    searchQuery: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          setTimeout(() => {
            this.showModal()
          }, 10000)
        }
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (
        !['searchResults', 'hsCode'].includes(this.$route.name) &&
        !this.$store.state.initalModalShown
      ) {
        this.$store.dispatch('initialModalShown')
        this.showModal()
      } else if (['searchResults', 'hsCode'].includes(this.$route.name)) {
        this.showModal()
      }
    }, 10000)
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100vw;
  background: #fff;
  padding: 20px;
  text-align: center;

  .cross-icon {
    float: right;
    margin: 5px;
  }
}
</style>
